import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { useForm } from 'react-hook-form';
import { CustomFormField } from '../component';

export const AlertDialog = ({
    title = 'Confirm', description = '',
    primaryButton = '', secondaryButton = 'cancel',
    show = false,
    showReason = true, reasonLabel = '',
    handleConfirmation,
    handleCancel
}) => {
    const {
        control,
        reset,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: {
            reason: '',
        }
    })

    const onSubmit = (formData) => {
        handleConfirmation(formData?.reason)
        reset()
    }

    return (
        <Dialog
            fullWidth
            open={show}
            onClose={handleCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <div style={{ padding: '0px 20px 20px' }}>
                <div style={{ marginBottom: 10 }}>
                    {description}
                </div>
                {showReason
                    ? <form onSubmit={handleSubmit(onSubmit)} noValidate>
                        <CustomFormField label={reasonLabel} control={control} name={'reason'} errorMessage={errors?.reason?.message} placeholder='Reason' rules={{ required: 'Reason is required' }} />
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                            <Button variant="contained" color="primary" type="submit">
                                Submit
                            </Button>
                            <Button
                                variant="outlined"
                                style={{ marginLeft: 10 }}
                                color="primary"
                                onClick={() => {
                                    reset();
                                    handleCancel()
                                }}>
                                {secondaryButton}
                            </Button>
                        </div>
                    </form>
                    : <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                        {primaryButton?.length
                            ? <Button variant="contained"
                                color={primaryButton?.toLowerCase() === "delete" ? "error" : "primary"}
                                onClick={() => handleConfirmation()}>
                                {primaryButton}
                            </Button>
                            : <div />
                        }
                        <Button variant="outlined" style={{ marginLeft: 10 }} color="primary" onClick={() => { reset(); handleCancel() }}>
                            {secondaryButton}
                        </Button>
                    </div>
                }
            </div>
        </Dialog>
    );
}